import { IModule } from 'redux-dynamic-modules';
import { offeringsSlice } from './offerings.slice';
import { OFFERINGS_SLICE_NAME, OfferingsOwnState } from './offerings.types';

export const getOfferingsModule = (): IModule<OfferingsOwnState> => ({
  id: OFFERINGS_SLICE_NAME,
  reducerMap: {
    [OFFERINGS_SLICE_NAME]: offeringsSlice.reducer,
  },
  retained: true,
});
